import{mirrorEasing as r}from"./modifiers/mirror.mjs.js";import{reverseEasing as o}from"./modifiers/reverse.mjs.js";const s=r=>1-Math.sin(Math.acos(r)),m=o(s),i=r(s);export{s as circIn,i as circInOut,m as circOut};
